import { useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';

const DISMISS_KEY = 'non_us_banner_dismissed';

export default function NonUsBanner() {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem(DISMISS_KEY) === '1';
    } catch {
      return false;
    }
  });

  if (dismissed) return null;

  const handleDismiss = () => {
    try {
      sessionStorage.setItem(DISMISS_KEY, '1');
    } catch {
      // ignore
    }
    setDismissed(true);
  };

  return (
    <div className="bg-amber-50 border-b border-amber-200 text-amber-900">
      <div className="max-w-6xl mx-auto px-4 py-3 flex items-start gap-3">
        <AlertTriangle className="w-5 h-5 flex-shrink-0 mt-0.5 text-amber-600" />
        <div className="flex-1 text-sm">
          <p className="font-medium">Surveys are only available to US residents.</p>
          <p className="mt-1 text-amber-800">
            Looks like you&rsquo;re currently outside the US &mdash; your surveys will be waiting
            when you return home. Traveling long-term?{' '}
            <a
              href="mailto:support@swipeopinion.com"
              className="underline hover:text-amber-950"
            >
              Contact support
            </a>
            .
          </p>
        </div>
        <button
          onClick={handleDismiss}
          aria-label="Dismiss"
          className="flex-shrink-0 p-1 rounded hover:bg-amber-100 transition"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
